import { useState } from "react";
import { FormattedMessage } from "react-intl";
import { IubendaPolicy } from "~/components/IubendaPolicy";
import { IubendaTerms } from "~/components/IubendaTerms";
import { Button } from "~/components/ui/button";
import { Modal } from "~/components/ui/modal";

interface TermsAndPolicyDialogProps {
  children: React.ReactNode;
  type: "terms" | "policy";
}

export const TermsAndPolicyDialog = ({
  children,
  type,
}: TermsAndPolicyDialogProps) => {
  const [open, setOpen] = useState(false);

  const title = type === "terms" ? "Terms and Conditions" : "Privacy Policy";

  return (
    <>
      <span
        onClick={(e) => {
          e.preventDefault();
          setOpen(true);
        }}
        className="inline-block"
      >
        {children}
      </span>
      <Modal
        title={title}
        description={null}
        content={type === "terms" ? <IubendaTerms /> : <IubendaPolicy />}
        footer={
          <Button type="button" onClick={() => setOpen(false)}>
            <FormattedMessage id="close" />
          </Button>
        }
        open={open}
        onOpenChange={setOpen}
      />
    </>
  );
};
